import styles from './AuthTabs.module.css';
import { t } from '@/i18n';

export type AuthTab = 'login' | 'register';

interface AuthTabsProps {
  value: AuthTab;
  onChange: (v: AuthTab) => void;
}

export function AuthTabs({ value, onChange }: AuthTabsProps) {
  return (
    <div className={styles.tabs} role="tablist" aria-label={t.auth.tabsAria}>
      <button
        type="button"
        role="tab"
        aria-selected={value === 'login'}
        className={[styles.tab, value === 'login' ? styles.active : ''].filter(Boolean).join(' ')}
        onClick={() => onChange('login')}
      >
        {t.auth.login}
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={value === 'register'}
        className={[styles.tab, value === 'register' ? styles.active : ''].filter(Boolean).join(' ')}
        onClick={() => onChange('register')}
      >
        {t.auth.register}
      </button>
    </div>
  );
}
